import { render, staticRenderFns } from "./GiveAccessToEmployeeModal.vue?vue&type=template&id=7e9b1ad9&scoped=true"
import script from "./GiveAccessToEmployeeModal.vue?vue&type=script&lang=js"
export * from "./GiveAccessToEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./GiveAccessToEmployeeModal.vue?vue&type=style&index=0&id=7e9b1ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b1ad9",
  null
  
)

export default component.exports